import React from 'react';
import { Box } from '@mui/material';

export const Logo = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <a href='/' style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src='/assets/images/BCAA_Marketplace_Task_Horiz_RGB_White.png'
                    alt='BCAA Logo'
                    style={{ height: 30 }}
                />
            </a>
        </Box>
    );
};
